import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import logoBlack from "../images/common/logo-black.svg";
import getCookie from "../function/getCookie";
import ringImage from "../images/sizeguide/size_guide_banner_r.jpg";
import necklaceImage from "../images/sizeguide/size_guide_banner_n.jpg";
import necklaceImage2 from "../images/sizeguide/sizeguide_N_807.jpg";
import ringSize from "../images/sizeguide/r_size.jpg";
import innerImg from "../images/sizeguide/inner_TC.jpg";
import bangleImage from "../images/sizeguide/size_guide_banner_k.jpg";
import braceletImage from "../images/sizeguide/size_guide_banner_b.jpg";
import measure01Image from "../images/sizeguide/b_size.jpg";
import measure02Image from "../images/sizeguide/b_size_2.jpg";
import measure03Image from "../images/sizeguide/b_size_3.jpg";
import { ROOT } from "../constants";
import "../css/addOnSizeGuide.css";
import "../css/SizeGuide.css";

let $ = window.$;

function SizeGuide({ sizeGuideAnchor, t, i18n }) {
  const [activeBraceletTab, setActiveBraceletTab] = useState("clasp");

  useEffect(() => {
    $(`a[href='${sizeGuideAnchor}']`).tab("show");
  }, [sizeGuideAnchor]);

  function handleTab(tab) {
    setActiveBraceletTab(tab);
  }

  return (
    <div
      className="modal modalEMP fade"
      id="modal_sizeGuide"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal_sizeGuide_title"
      aria-hidden="true"
      style={{ display: "none" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          {/* header */}
          <div className="modal-header">
            <div className="title_desktop_wrap d-none d-md-block">
              <span className="title text-uppper">
                {t("sizeGuide.rings.sizeGuide")}
              </span>
              <button
                type="button"
                className="close closeBtn"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span className="stroke" aria-hidden="true"></span>
                <span className="stroke" aria-hidden="true"></span>
              </button>
            </div>
            <div className="title_mobile_wrap d-block d-md-none">
              <button
                type="button"
                className="close backBtn d-block d-md-none"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span className="stroke" aria-hidden="true"></span>
                <span className="stroke" aria-hidden="true"></span>
              </button>
              <span className="title text-uppper">
                {t("sizeGuide.rings.sizeGuide")}
              </span>
            </div>
          </div>
          {/* body */}
          <div className="modal-body" style={{ paddingBottom: "0" }}>
            <div className="content">
              <div className="container-fluid nav-container">
                <ul className="nav nav-tabs justify-content-center">
                  <li className="nav-item">
                    <a
                      className="nav-link text-uppper"
                      id="guide-bracelets-nav"
                      data-toggle="tab"
                      href="#guide-bracelets"
                    >
                      {t("sizeGuide.bracelet.bookmark")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link text-uppper"
                      id="guide-bangles-nav"
                      data-toggle="tab"
                      href="#guide-bangles"
                    >
                      {t("sizeGuide.bangles.bangles")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link text-uppper"
                      id="guide-necklaces-nav"
                      data-toggle="tab"
                      href="#guide-necklaces"
                    >
                      {t("sizeGuide.necklaces.necklacesName")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link text-uppper"
                      id="guide-rings-nav"
                      data-toggle="tab"
                      href="#guide-rings"
                    >
                      {t("sizeGuide.rings.rings")}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="container-fluid">
                <div className="content-separator"></div>
              </div>
              <div className="container-fluid">
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane"
                    id="guide-bracelets"
                  >
                    <div className="guide-desc">
                      <p>
                        {i18n.language === "en" ? (
                          "To determine which bracelet length suits you, measure your wrist tightly using below method."
                        ) : (
                          <>
                            為了讓您佩帶貼心舒適，請參照以下量度方法，
                            <span className="desktop-d-none mobile-d-block"></span>
                            選擇適合自己的手鍊尺寸。
                          </>
                        )}
                      </p>
                      <p>
                        {i18n.language === "en" ? (
                          "Most of our bracelets include an extender to ensure a more personalised fit. The size you see is inclusive of the extender length. If you are between sizes, choose the smaller size if you like to wear your bracelet tightly, or take the next size up if you prefer it loose."
                        ) : (
                          <>
                            大部分手錬包含錬段，讓您佩帶更舒適貼合。
                            <span className="desktop-d-none mobile-d-block"></span>
                            尺碼包含鍊段長度。如果手腕在兩個尺寸之間，
                            <span className="desktop-d-none mobile-d-block"></span>
                            可按照佩戴習慣選擇較鬆（尺寸較大）或較緊（尺寸較小）的尺寸。
                          </>
                        )}
                      </p>
                    </div>
                    <div className="guide-desc-title">
                      {i18n.language === "en"
                        ? "Measure your wrist"
                        : "量度手腕"}
                    </div>
                    <div className="sub-nav-container">
                      <ul className="sub-nav sub-nav-tabs">
                        <li className="sub-nav-item">
                          <div
                            className={`sub-nav-link ${
                              activeBraceletTab === "clasp" ? "active" : ""
                            }`}
                            id="clasp-bracelet"
                            onClick={handleTab.bind(this, "clasp")}
                          >
                            {i18n.language === "en" ? (
                              <b>Clasp bracelet</b>
                            ) : (
                              <b>環扣型手鍊</b>
                            )}
                          </div>
                        </li>
                        <li className="sub-nav-item">
                          <div
                            className={`sub-nav-link ${
                              activeBraceletTab === "slipon" ? "active" : ""
                            }`}
                            id="slip-on-bracelet"
                            onClick={handleTab.bind(this, "slipon")}
                          >
                            {i18n.language === "en" ? (
                              <b>Slip-on bracelet</b>
                            ) : (
                              <b>套箍型手繩</b>
                            )}
                          </div>
                        </li>
                      </ul>
                    </div>
                    <section className="guide-desc-content-warpper">
                      <div className="guide-desc-detail clearfix">
                        <div
                          className={`guide-desc-detail-left ${
                            activeBraceletTab === "clasp"
                              ? "active"
                              : "mobileHidden"
                          }`}
                        >
                          <p className="guide-desc-detail-text mobileHidden">
                            {i18n.language === "en"
                              ? "Clasp bracelet"
                              : "環扣型手鍊"}
                          </p>
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bracelets/bracelets_1-1.jpg"
                            alt=""
                            loading="lazy"
                          />
                        </div>
                        <div
                          className={`guide-desc-detail-right ${
                            activeBraceletTab === "slipon"
                              ? "active"
                              : "mobileHidden"
                          }`}
                        >
                          <p className="guide-desc-detail-text mobileHidden">
                            {i18n.language === "en"
                              ? "Slip-on bracelet"
                              : "套箍型手繩"}
                          </p>
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bracelets/bracelets_2-1.jpg"
                            alt=""
                            loading="lazy"
                          />
                        </div>
                      </div>
                      <div className="guide-desc-detail clearfix">
                        <div
                          className={`guide-desc-detail-left ${
                            activeBraceletTab === "clasp"
                              ? "active"
                              : "mobileHidden"
                          }`}
                        >
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bracelets/bracelets_1-2.jpg"
                            alt=""
                            loading="lazy"
                          />
                          <p>{t("sizeGuide.bracelet.measuringMethods1-1")}</p>
                        </div>
                        <div
                          className={`guide-desc-detail-right ${
                            activeBraceletTab === "slipon"
                              ? "active"
                              : "mobileHidden"
                          }`}
                        >
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bracelets/bracelets_2-2.jpg"
                            alt=""
                            loading="lazy"
                          />
                          <p>{t("sizeGuide.bracelet.measuringMethods2-1")}</p>
                        </div>
                      </div>
                      <div className="guide-desc-detail clearfix">
                        <div
                          className={`guide-desc-detail-left ${
                            activeBraceletTab === "clasp"
                              ? "active"
                              : "mobileHidden"
                          }`}
                        >
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bracelets/bracelets_1-3.png"
                            alt=""
                            loading="lazy"
                          />
                          <p>{t("sizeGuide.bracelet.measuringMethods1-2")}</p>
                        </div>
                        <div
                          className={`guide-desc-detail-right ${
                            activeBraceletTab === "slipon"
                              ? "active"
                              : "mobileHidden"
                          }`}
                        >
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bracelets/bracelets_2-3.png"
                            alt=""
                            loading="lazy"
                          />
                          <p>{t("sizeGuide.bracelet.measuringMethods2-2")}</p>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div role="tabpanel" className="tab-pane" id="guide-bangles">
                    <div className="guide-desc">
                      <p>
                        {i18n.language === "en" ? (
                          "To determine your EMPHASIS bangle size, measure your wrist and compare your measurement with the correspondence table below."
                        ) : (
                          <>
                            為了讓您佩戴得貼心舒適，請先量度手腕尺寸，
                            <br />
                            再參照以下EMPHASIS手鐲尺寸對照表，選擇適合自己的手鐲尺寸。
                          </>
                        )}
                      </p>
                    </div>
                    <div className="guide-desc-title">
                      {i18n.language === "en"
                        ? "Measure your wrist"
                        : "量度手腕"}
                    </div>
                    <section className="guide-desc-content-warpper clearfix">
                      <div className="guide-desc-detail clearfix">
                        <div className="guide-desc-detail-left mobileHidden">
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bangles/bangles_1-1.jpg"
                            alt=""
                            loading="lazy"
                          />
                        </div>
                        <div className="guide-desc-detail-right mobileShow">
                          <div>
                            <img
                              src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bangles/bangles_1-2.jpg"
                              alt=""
                              loading="lazy"
                            />
                            <p>{t("sizeGuide.bangles.measure1Step1")}</p>
                          </div>
                          <div>
                            <img
                              src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bangles/bangles_1-3.jpg"
                              alt=""
                              loading="lazy"
                            />
                            <p>{t("sizeGuide.bangles.measure1Step2")}</p>
                          </div>
                        </div>
                      </div>
                      <div className="guide-desc-detail clearfix">
                        <div className="guide-desc-detail-left">
                          <p className="guide-desc-detail-text">
                            {i18n.language === "en"
                              ? "Closed bangle"
                              : "閉口手鐲"}
                          </p>
                          <p className="guide-desc-detail-text-grey">
                            {i18n.language === "en"
                              ? "Bangle diameter"
                              : "手鐲直徑"}
                          </p>
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bangles/bangles_2-1.png"
                            alt=""
                            loading="lazy"
                          />
                        </div>
                        <div className="guide-desc-detail-right">
                          <p className="guide-desc-detail-text">
                            {i18n.language === "en"
                              ? "Semi-open bangle"
                              : "半開口手鐲"}
                          </p>
                          <p className="guide-desc-detail-text-grey">
                            {i18n.language === "en"
                              ? "Bangle diameter"
                              : "手鐲直徑"}
                          </p>
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/bangles/bangles_2-2.png"
                            alt=""
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </section>
                    <section className="guide-desc-content-warpper clearfix">
                      <table
                        border="0"
                        cellSpacing="0"
                        cellPadding="0"
                        className="sizeguidetable"
                      >
                        <tbody>
                          <tr>
                            <th className="">
                              {i18n.language === "en"
                                ? "Recommended bangle size"
                                : "建議手鐲尺碼"}
                            </th>
                            <th className="">
                              {i18n.language === "en"
                                ? "Wrist size"
                                : "手腕尺寸"}
                            </th>
                            <th className="">
                              {i18n.language === "en"
                                ? "Bangle diameter"
                                : "手鐲直徑"}
                            </th>
                          </tr>
                          <tr>
                            <td className="">06</td>
                            <td className="">14.0 - 15.0 cm</td>
                            <td className="">5.4 cm</td>
                          </tr>
                          <tr>
                            <td className="">07</td>
                            <td className="">14.5 - 15.5 cm</td>
                            <td className="">5.6 cm</td>
                          </tr>
                          <tr>
                            <td className="">08</td>
                            <td className="">15.0 - 16.0 cm</td>
                            <td className="">5.8 cm</td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane"
                    id="guide-necklaces"
                  >
                    <div className="guide-desc">
                      <p>
                        {i18n.language === "en" ? (
                          "To make it easy for you to find the size you are looking for, we have created a visual to give you an idea how long the necklace will be on you."
                        ) : (
                          <>
                            為了幫助您尋找最理想的頸鍊，請參照EMPHASIS頸鍊長度指南，
                            <br />
                            選擇適合自己的頸鍊長度。
                          </>
                        )}
                      </p>
                    </div>
                    <section className="guide-desc-content-warpper clearfix">
                      <div className="guide-desc-detail clearfix">
                        <div className="guide-desc-detail-left">
                          <img
                            src="https://cdn.chowsangsang.com/emphasis/web/sizeGuide/necklace/necklaces_1-1.jpg"
                            alt=""
                            loading="lazy"
                          />
                          <p className="guide-desc-detail-remarks">
                            {t(
                              "sizeGuide.necklaces.necklacesNoteForReferenceImage"
                            )}
                          </p>
                        </div>
                        <div className="guide-desc-detail-right">
                          <div>
                            <h2 className="sizeguidetable-title">
                              {t("sizeGuide.necklaces.lengthOfNecklace")}
                            </h2>
                            <table
                              border="0"
                              cellSpacing="0"
                              cellPadding="0"
                              className="sizeguidetable"
                            >
                              <tbody>
                                <tr>
                                  <th className="">
                                    {i18n.language === "en"
                                      ? "Centimetres"
                                      : "厘米"}
                                  </th>
                                  <th className="">
                                    {i18n.language === "en" ? "Inches" : "英寸"}
                                  </th>
                                </tr>
                                <tr>
                                  <td className="">42cm</td>
                                  <td className="">16.5”</td>
                                </tr>
                                <tr>
                                  <td className="">47cm</td>
                                  <td className="">18.5”</td>
                                </tr>
                                <tr>
                                  <td className="">57cm</td>
                                  <td className="">22.5”</td>
                                </tr>
                                <tr>
                                  <td className="">80cm</td>
                                  <td className="">31.5”</td>
                                </tr>
                                <tr>
                                  <td className="">90cm</td>
                                  <td className="">35.5”</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div role="tabpanel" className="tab-pane" id="guide-rings">
                    <div className="guide-desc">
                      <p>
                        {i18n.language === "en" ? (
                          "EMPHASIS uses standard Hong Kong, China ring sizes. We have prepared a ring size guide to help you determine your size. Before you begin, there are a few recommendations to ensure an accurate measure:"
                        ) : (
                          <>
                            EMPHASIS戒指尺寸以中國香港為標準。為了讓您佩戴得舒適貼心，請根據以下的戒指尺寸量度指引，
                            <br />
                            找出適合您的戒指圈口。為讓更準確量度，請先閱以下溫馨提示
                            :
                          </>
                        )}
                      </p>
                      <p>
                        {i18n.language === "en"
                          ? "The size of your fingers can vary depending on the time of day. If possible, take measurements at the end of the day. Your ring should fit your intended finger comfortably:"
                          : "想要量度更加精準，建議於晚上量度為佳。"}
                        <br />
                        {i18n.language === "en"
                          ? "snug enough so that it will not fall off, but loose enough to slide over your knuckle."
                          : "最理想的戒指尺寸，應該是鬆緊有致，既不會輕易滑出指關節，也不會勒得過緊。"}
                        <br />
                        {i18n.language === "en"
                          ? "Ring sizes may also vary slightly depending on the style of the ring."
                          : "戒指尺寸也可能因戒指的款式而略有不同。"}
                      </p>
                    </div>
                    <div className="text-right text-primary">
                      <p>
                        <a
                          href={
                            i18n.language === "en"
                              ? "https://cdn.chowsangsang.com/emphasis/web/sizeGuide/rings/Ring_Size_Eng_revised-pdf.pdf"
                              : "https://cdn.chowsangsang.com/emphasis/web/sizeGuide/rings/Ring_Size_TC_revised-pdf.pdf"
                          }
                          target="_blank"
                          className="content-link"
                        >
                          <span className="icon-download"></span>{" "}
                          {t("sizeGuide.rings.downloadRingSG")}
                        </a>
                      </p>
                    </div>

                    <section className="guide-desc-content-warpper clearfix">
                      <table
                        border="0"
                        cellPadding="3"
                        cellSpacing="0"
                        className="
                          sizeguidetable
                          FontSizeSmall
                          productSizeGuideSpan480
                        "
                      >
                        <tbody>
                          <tr>
                            <th className="" rowSpan="2">
                              {i18n.language === "en" ? (
                                <>
                                  Inside
                                  <br />
                                  Circumference
                                </>
                              ) : (
                                "內圓周"
                              )}
                              <br />
                              (mm)
                            </th>
                            <th className="" rowSpan="2">
                              {i18n.language === "en" ? (
                                <>
                                  Inside
                                  <br />
                                  Diameter
                                </>
                              ) : (
                                "內圓直徑"
                              )}
                              <br />
                              (mm)
                            </th>
                            <th className="" colSpan="4">
                              {i18n.language === "en"
                                ? "Ring size"
                                : "戒指尺碼"}
                            </th>
                          </tr>
                          <tr>
                            <th className="">
                              {t("sizeGuide.rings.HKSAR1")}
                              <br />
                              (EMPHASIS)
                            </th>
                            <th className="">{t("sizeGuide.rings.china")}</th>
                            <th className="">
                              {t("sizeGuide.rings.US&Canada")}
                            </th>
                            <th className="">{t("sizeGuide.rings.japan")}</th>
                          </tr>
                          <tr>
                            <td className="">45.5</td>
                            <td className="">14.5</td>
                            <td className="">7</td>
                            <td className="">5.5</td>
                            <td className="">3.5</td>
                            <td className="">5</td>
                          </tr>
                          <tr>
                            <td className="">46.5</td>
                            <td className="">14.8</td>
                            <td className="">8</td>
                            <td className="">6.5</td>
                            <td className="">3.75</td>
                            <td className="">6</td>
                          </tr>
                          <tr>
                            <td className="">47.7</td>
                            <td className="">15.2</td>
                            <td className="">9</td>
                            <td className="">8</td>
                            <td className="">4.25</td>
                            <td className="">7</td>
                          </tr>
                          <tr>
                            <td className="">48.7</td>
                            <td className="">15.5</td>
                            <td className="">10</td>
                            <td className="">9</td>
                            <td className="">4.75</td>
                            <td className="">8</td>
                          </tr>
                          <tr>
                            <td className="">49.9</td>
                            <td className="">15.9</td>
                            <td className="">11</td>
                            <td className="">10</td>
                            <td className="">5.25</td>
                            <td className="">9</td>
                          </tr>
                          <tr>
                            <td className="">50.9</td>
                            <td className="">16.2</td>
                            <td className="">12</td>
                            <td className="">11</td>
                            <td className="">5.5</td>
                            <td className="">10</td>
                          </tr>
                          <tr>
                            <td className="">52.1</td>
                            <td className="">16.6</td>
                            <td className="">13</td>
                            <td className="">12</td>
                            <td className="">6</td>
                            <td className="">11</td>
                          </tr>
                          <tr>
                            <td className="">53.1</td>
                            <td className="">16.9</td>
                            <td className="">14</td>
                            <td className="">13</td>
                            <td className="">6.5</td>
                            <td className="">12</td>
                          </tr>
                          <tr>
                            <td className="">54.3</td>
                            <td className="">17.3</td>
                            <td className="">15</td>
                            <td className="">14</td>
                            <td className="">7</td>
                            <td className="">13.5</td>
                          </tr>
                          <tr>
                            <td className="">55.6</td>
                            <td className="">17.7</td>
                            <td className="">16</td>
                            <td className="">15.5</td>
                            <td className="">7.5</td>
                            <td className="">14.5</td>
                          </tr>
                          <tr>
                            <td className="">56.5</td>
                            <td className="">18</td>
                            <td className="">17</td>
                            <td className="">16.5</td>
                            <td className="">7.75</td>
                            <td className="">15.5</td>
                          </tr>
                          <tr>
                            <td className="">57.5</td>
                            <td className="">18.3</td>
                            <td className="">18</td>
                            <td className="">17.5</td>
                            <td className="">8.25</td>
                            <td className="">16.5</td>
                          </tr>
                          <tr>
                            <td className="">58.7</td>
                            <td className="">18.7</td>
                            <td className="">19</td>
                            <td className="">19</td>
                            <td className="">8.75</td>
                            <td className="">17.5</td>
                          </tr>
                          <tr>
                            <td className="">59.7</td>
                            <td className="">19</td>
                            <td className="">20</td>
                            <td className="">20</td>
                            <td className="">9</td>
                            <td className="">18.5</td>
                          </tr>
                          <tr>
                            <td className="">60.9</td>
                            <td className="">19.4</td>
                            <td className="">21</td>
                            <td className="">21</td>
                            <td className="">9.5</td>
                            <td className="">19.5</td>
                          </tr>
                          <tr>
                            <td className="">61.9</td>
                            <td className="">19.7</td>
                            <td className="">22</td>
                            <td className="">22</td>
                            <td className="">10</td>
                            <td className="">20.5</td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="content-separator"></div>
                      <p className="rings-remarks-title">
                        {t("sizeGuide.rings.freeResizing")}
                      </p>
                      <div className="guide-desc">
                        <p>{t("sizeGuide.rings.dontWorry")}</p>
                      </div>
                    </section>
                  </div>
                </div>
                <div className="modal-footer">
                  <p>
                    {i18n.language === "en"
                      ? "If you require any assistance, please contact customer service at +852 2192 3228."
                      : "如需任何協助，請聯絡顧客服務熱線 +852 2192 3228。"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(SizeGuide);
